module.exports = __webpack_public_path__ + "static/key-beathaz-047f7b9f5f0f45416f9d35fec41cdbbe.webp";